// extracted by mini-css-extract-plugin
export var closeButton = "_kr-2";
export var closeButtonIcon = "_kr-3";
export var lightboxContent = "_kr-1";
export var lightboxOverlay = "_kr-0";